import { Route } from "react-router-dom";
import PatientHome from "../../layout/app/patient-portal/PatientHome";
import PatientPortalAppointment from "../../layout/app/patient-portal/PatientPortalAppointment";
import PatientPortalLayout from "../../layout/app/patient-portal/PatientPortalLayout";
import PatientPortalDashBoard from "../../layout/app/patient-portal/dashboard/PatientPortalDashBoard";
import PatientForms from "../../layout/app/patient-portal/forms/PatientForms";
// import PatientAppointments from "../../layout/app/patient-portal/appointments/PatientAppointments";
import AppointmentCalendar from "../../layout/app/patient-portal/appointment/components/AppointmentCalendar";
import PatientPortalAppointmentList from "../../layout/app/patient-portal/appointment/components/PatientPortalAppointmentList";
import PatientBilling from "../../layout/app/patient-portal/billing/PatientBillingLayout";
import PayementsDue from "../../layout/app/patient-portal/billing/PayementsDue";
import PaymentHistory from "../../layout/app/patient-portal/billing/PaymentHistory";
import SavedCards from "../../layout/app/patient-portal/billing/SavedCards";
import PatientCommunication from "../../layout/app/patient-portal/communication/PatientPortalCommunication";
import PatientCompletedDocument from "../../layout/app/patient-portal/documents/PatientCompletedDocument";
import PatientDocuments from "../../layout/app/patient-portal/documents/PatientDocuments";
import PatientIncompleteDocument from "../../layout/app/patient-portal/documents/PatientIncompleteDocument";
import PatientHealthRecord from "../../layout/app/patient-portal/health-record/PatientHealthRecord";
import PatientPortalAllergies from "../../layout/app/patient-portal/health-record/PatientPortalAllergies";
import PatientPortalCarePlan from "../../layout/app/patient-portal/health-record/PatientPortalCarePlan";
import PatientPortalImmunization from "../../layout/app/patient-portal/health-record/PatientPortalImmunization";
import PatientPortalMedicalHistory from "../../layout/app/patient-portal/health-record/PatientPortalMedicalHistory";
import PatientPortalPastVisit from "../../layout/app/patient-portal/health-record/PatientPortalPastVisit";
import PatientPortalTask from "../../layout/app/patient-portal/patient-task/PatientPortalTask";
import PatientProviderProfile from "../../layout/app/patient-portal/providers/PatientProviderProfile";
import PatientProviders from "../../layout/app/patient-portal/providers/PatientProviders";
import PatientPortalNotifications from "../../layout/app/patient-portal/settings/PatientPortalNotifications";
import PatientPortalProfile from "../../layout/app/patient-portal/settings/PatientPortalProfile";
import ProviderPortalPatientSettings from "../../layout/app/patient-portal/settings/ProviderPortalPatientSettings";
import PatientPortalInsurance from "../../layout/app/patient-portal/settings/patientPortalInsurance";
import Chat from "../../pages/app/provider/communications/chat/Chat";
// import PatientOrderNewLayout from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/PatientOrderLayout";
// import PatientOrderNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/orders/PatientOrderNew";
// import OderResultNew from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/result/OderResultNew";
import PatientPortalEmailTable from "../../layout/app/patient-portal/communication/email/PatientPortalEmailTable";
import PatientPortalOrders from "../../layout/app/patient-portal/health-record/PatientPortalOrders";
import PatientOrderNewHealthV2 from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/orders/PatientOrderNewHealthV2";
import OrderReportsHealthV2 from "../../pages/app/provider/patient/patient-list/patient-chart-new/order/result/OrderReportsHealthV2";
import { ProtectedRoute } from "../Router";

export const PatientRoute = () => {
  return (
    <Route
      path="patient"
      element={
        <ProtectedRoute accessingViewAs="patient">
          <PatientPortalLayout />
        </ProtectedRoute>
      }
    >
      <Route path="home" element={<PatientHome />} />
      <Route path="dashboard" element={<PatientPortalDashBoard />} />
      {/* <Route path="appointments" element={<PatientAppointments />} /> */}
      <Route path="providers" element={<PatientProviders />} />
      <Route
        path="providers/:providerUuid"
        element={<PatientProviderProfile />}
      />

      <Route path="communication" element={<PatientCommunication />}>
        {/* <Route index element={<SmsText />} /> */}
        <Route path="chat" element={<Chat />} />
        <Route path="email" element={<PatientPortalEmailTable />} />
      </Route>
      <Route path="billing" element={<PatientBilling />} />

      <Route path="documents" element={<PatientDocuments />}>
        <Route index element={<PatientIncompleteDocument />} />
        <Route path="completed" element={<PatientCompletedDocument />} />
      </Route>

      <Route path="billing" element={<PatientBilling />}>
        <Route index element={<PayementsDue />} />
        <Route path="paymentsMade" element={<PaymentHistory />} />
        <Route path="savedCards" element={<SavedCards />} />
      </Route>
      <Route path="documents" element={<PatientDocuments />} />

      <Route path="health-record" element={<PatientHealthRecord />}>
        <Route index element={<PatientPortalMedicalHistory />} />
        <Route path="immunization" element={<PatientPortalImmunization />} />
        <Route path="allergies" element={<PatientPortalAllergies />} />
        <Route path="careplan" element={<PatientPortalCarePlan />} />
        {/* <Route path="order" element={<PatientOrderNewLayout />}>
          <Route index element={<PatientOrderNewHealthV2 />} />
          <Route path="result" element={<OderResultNewHealthV2 />} />
        </Route> */}
        <Route path="order" element={<PatientPortalOrders />}>
          <Route index element={<PatientOrderNewHealthV2 />} />
          <Route path="reports" element={<OrderReportsHealthV2 />} />
        </Route>
        <Route path="past-visit" element={<PatientPortalPastVisit />} />
      </Route>

      <Route path="settings" element={<ProviderPortalPatientSettings />}>
        <Route index element={<PatientPortalProfile />} />
        <Route path="insurance" element={<PatientPortalInsurance />} />
        <Route path="notifications" element={<PatientPortalNotifications />} />
      </Route>
      <Route path="tasks" element={<PatientPortalTask />} />

      <Route path="appointments" element={<PatientPortalAppointment />}>
        <Route index element={<PatientPortalAppointmentList />} />
        <Route path="calendar" element={<AppointmentCalendar />} />
      </Route>
      <Route path="forms" element={<PatientForms />} />
    </Route>
  );
};
